"use client"

import Link from "next/link"
import { usePathname } from "next/navigation"
import { useSSECounts } from "@/context/SSEContext"

export default function ProjectsNavBadge() {
  const { activityCount } = useSSECounts()
  const pathname = usePathname()
  const isActive = pathname.startsWith("/projects")

  return (
    <Link
      href="/projects"
      className="px-3 py-2 text-sm font-medium rounded-md transition-colors relative"
      style={{ color: isActive ? "#f1f5f9" : "#94a3b8" }}
      onMouseOver={e => (e.currentTarget.style.color = "#f1f5f9")}
      onMouseOut={e => (e.currentTarget.style.color = isActive ? "#f1f5f9" : "#94a3b8")}
    >
      Projects
      {activityCount > 0 && (
        <span className="absolute top-1.5 -right-0.5 bg-red-500 rounded-full h-2 w-2" />
      )}
    </Link>
  )
}
